var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"timeline"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,staticClass:"timeline__step",class:{
      'timeline__step--completed': _vm.handleIsStepCompleted(step),
      'timeline__step--current': _vm.handleIsStepCurrent(step)
    }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }